interface IProps {
  htmlStr: string
}

function RenderHtmlFromString({ htmlStr }: IProps) {
  return <span dangerouslySetInnerHTML={{ __html: htmlStr }} />
}

export default RenderHtmlFromString
